import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql, navigate } from 'gatsby'
import FullWidth from './fullWidth'
import { TalkWithFoundersCta } from './SignUp'

import * as styles from './hero.module.css'
import './layout.css'

const Layout = ({ children, nakedBar, trialCta, slackApp, pricing }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <FullWidth className={styles.bottomShadow}>
          <div className={styles.topBar}>
            <div
              role="link"
              tabIndex="0"
              className={styles.logo}
              onClick={() => {
                navigate('/')
              }}
            >
              &nbsp;
            </div>
            <div className={styles.topBarActions}>
              {slackApp && (
                <div className={styles.navLink}>
                  <a href="/case-studies/castle">Case Studies</a>
                </div>
              )}
              <div className={styles.navLink}>
                <a href="/saas-metrics" target="_blank">
                  SaaS calculators
                </a>
              </div>
              {pricing && (
                <div className={styles.navLink}>
                  <a href="#pricing">Pricing</a>
                </div>
              )}
              {trialCta && <TalkWithFoundersCta />}
            </div>
          </div>
        </FullWidth>
        {children}
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
